interface LogoProps {
  className?: string;
  width?: number;
  height?: number;
}

export function Logo({
  className = '',
  width = 64,
  height = 64
}: LogoProps) {
  return (
    <div className={`relative ${className}`} style={{ width, height }}>
      <svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full overflow-visible">
        {/* Outer Shell - Left Half */}
        <path
          d="M50 15C35 15 20 25 15 50C10 75 25 90 50 90"
          stroke="#e5e5e5"
          strokeWidth="3"
          strokeLinecap="round"
          className="opacity-90"
        />

        {/* Outer Shell - Right Half */}
        <path
          d="M58 15C73 15 88 25 93 50C98 75 83 90 58 90"
          stroke="#e5e5e5"
          strokeWidth="3"
          strokeLinecap="round"
          className="opacity-90"
        />

        {/* Inner Nut / Brain / Network */}
        <g>
          {/* The "Nut" shape */}
          <path d="M54 25C65 25 75 35 75 52C75 70 65 80 54 80" fill="#93c572" className="opacity-20" />

          {/* Network Nodes */}
          <circle cx="54" cy="35" r="2" fill="#93c572" />
          <circle cx="65" cy="45" r="2" fill="#93c572" />
          <circle cx="58" cy="55" r="2" fill="#93c572" />
          <circle cx="68" cy="65" r="2" fill="#93c572" />
          <circle cx="54" cy="70" r="2" fill="#93c572" />

          {/* Connections */}
          <path
            d="M54 35L65 45M65 45L58 55M58 55L68 65M68 65L54 70M54 35L58 55"
            stroke="#93c572"
            strokeWidth="1"
            className="opacity-60"
          />
        </g>
      </svg>
    </div>
  );
}
